import { render, staticRenderFns } from "./info-icon.svg.vue?vue&type=template&id=7510c20d&"
import script from "./info-icon.svg.vue?vue&type=script&lang=js&"
export * from "./info-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports